import {
  FIRST_FLOOR_IMG_URL,
  GROUND_FLOOR_IMG_URL,
  MEZZANINE_FLOOR_IMG_URL,
} from "./floor_images";
import i18n from "../../../i18n";
import elevator from "./elevator_positions";

let locations;
export default locations = [
  {
    floor: i18n.t("mezzanine_floor"),
    imageURL: MEZZANINE_FLOOR_IMG_URL,
    title: i18n.t("library"),
    marked_position_x: 244,
    marked_position_y: 60,
    ...elevator.library,
  },
  {
    floor: i18n.t("mezzanine_floor"),
    imageURL: MEZZANINE_FLOOR_IMG_URL,
    title: i18n.t("liaison_office"),
    marked_position_x: 145,
    marked_position_y: 107,
    ...elevator.restaurant,
  },
  {
    floor: i18n.t("first_floor"),
    imageURL: FIRST_FLOOR_IMG_URL,
    title: i18n.t("office_kid"),
    marked_position_x: 315,
    marked_position_y: 83,
    ...elevator.library,
  },
  {
    floor: i18n.t("mezzanine_floor"),
    imageURL: MEZZANINE_FLOOR_IMG_URL,
    title: i18n.t("internship_office_2"),
    marked_position_x: 132,
    marked_position_y: 105,
    ...elevator.restaurant,
  },
  {
    floor: i18n.t("mezzanine_floor"),
    imageURL: MEZZANINE_FLOOR_IMG_URL,
    title: i18n.t("student_care_office"),
    marked_position_x: 145,
    marked_position_y: 90,
    ...elevator.restaurant,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("gym"),
    marked_position_x: 55,
    marked_position_y: 53,
    ...elevator.none,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("uni_publications"),
    marked_position_x: 297,
    marked_position_y: 68,
    ...elevator.none,
  },
  {
    floor: i18n.t("first_floor"),
    imageURL: FIRST_FLOOR_IMG_URL,
    title: i18n.t("ergastirio_kid"),
    marked_position_x: 310,
    marked_position_y: 104,
    ...elevator.library,
  },
  {
    floor: i18n.t("first_floor"),
    imageURL: FIRST_FLOOR_IMG_URL,
    title: i18n.t("ergasthrio_texnologikhs_ekpaideusis"),
    marked_position_x: 330,
    marked_position_y: 93,
    ...elevator.library,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("student_restaurant"),
    marked_position_x: 55,
    marked_position_y: 85,
    ...elevator.none,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("concierge"),
    marked_position_x: 214,
    marked_position_y: 95,
    ...elevator.none,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("cafeteria"),
    marked_position_x: 150,
    marked_position_y: 99,
    ...elevator.none,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("uom_students_club"),
    marked_position_x: 259,
    marked_position_y: 52,
    ...elevator.none,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("post_office"),
    marked_position_x: 247,
    marked_position_y: 52,
    ...elevator.none,
  },
  {
    floor: i18n.t("first_floor"),
    imageURL: FIRST_FLOOR_IMG_URL,
    title: i18n.t("technical_support"),
    marked_position_x: 252,
    marked_position_y: 138,
    ...elevator.library,
  },
  {
    floor: i18n.t("ground_floor"),
    imageURL: GROUND_FLOOR_IMG_URL,
    title: i18n.t("photocopy_space"),
    marked_position_x: 139,
    marked_position_y: 34,
    ...elevator.none,
  },
];
